/* Copy do dashboard de métricas (ADR-0353/0359/0704/0811): header, seletor de moeda, botão de
   atualizar e os rótulos das 4 abas lazy-load. As abas em si (`RevenueTab`/`SubscribersTab`/
   `SignupsTab`/`ModerationTab`) são componentes externos — fora do escopo desta área. */
import type { Bilingual } from '../bilingual.js';
import { useBilingual } from '../locale-provider.js';

interface MetricsDashboardContent {
  readonly pageTitle: string;
  readonly pageDescription: string;
  readonly currencyAriaLabel: string;
  readonly refresh: string;
  readonly loadError: string;
  readonly tabs: {
    readonly revenue: string;
    readonly subscribers: string;
    readonly signups: string;
    readonly moderation: string;
  };
}

const METRICS_DASHBOARD_CONTENT: Bilingual<MetricsDashboardContent> = {
  'pt-BR': {
    pageTitle: 'Métricas',
    pageDescription: 'Receita, assinantes, cadastros e moderação — visão analítica do negócio.',
    currencyAriaLabel: 'Moeda',
    refresh: 'Atualizar',
    loadError: 'Falha ao carregar métricas. Tente novamente.',
    tabs: {
      revenue: 'Receita',
      subscribers: 'Assinantes',
      signups: 'Cadastros',
      moderation: 'Moderação',
    },
  },
  'en-US': {
    pageTitle: 'Metrics',
    pageDescription:
      'Revenue, subscribers, signups, and moderation — an analytical view of the business.',
    currencyAriaLabel: 'Currency',
    refresh: 'Refresh',
    loadError: 'Failed to load metrics. Try again.',
    tabs: {
      revenue: 'Revenue',
      subscribers: 'Subscribers',
      signups: 'Signups',
      moderation: 'Moderation',
    },
  },
};

export const useMetricsDashboardContent = (): MetricsDashboardContent =>
  useBilingual(METRICS_DASHBOARD_CONTENT);
